// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"0444e70f","609":"ce03c5ba","649":"b2ee81ad","827":"52352698"}[chunkId] + ".chunk.css";
};